module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "app-header-wrapper"
  }, [_c('div', {
    staticClass: "app-header-left"
  }, [(_vm.showMenu) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('menu')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), (_vm.showFavor) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('favor')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("folder")])], 1) : _vm._e(), _vm._v(" "), (_vm.showBack) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('back')
      }
    }
  }, [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), (_vm.showLogo) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.handleClick('logo')
      }
    }
  }, [_vm._t("logo", [_c('v-icon', {
    staticClass: "app-header-icon"
  }, [_vm._v(_vm._s(_vm.logoIcon))])])], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header-middle"
  }, [_vm._t("title", [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header-right"
  }, [_vm._l((_vm.actions), function(action, actionIdx) {
    return _vm._t("actions", [(action.toggle) ? _c('v-btn', {
      class: action.toggleClassObj,
      attrs: {
        "icon": "icon"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick('toggle', {
            actionIdx: actionIdx,
            handler: action.toggleHandler
          })
        }
      }
    }, [_c('v-icon', {
      staticClass: "app-header-icon"
    }, [_vm._v(_vm._s(action.toggleIcon))])], 1) : _c('v-btn', {
      attrs: {
        "icon": "icon"
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick('action', {
            actionIdx: actionIdx,
            route: action.route
          })
        }
      }
    }, [(action.svg) ? _c('icon', {
      staticClass: "app-header-icon",
      attrs: {
        "name": action.svg
      }
    }) : (action.icon) ? _c('v-icon', {
      staticClass: "app-header-icon"
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e()], 1)], {
      icon: action.icon,
      route: action.route
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad8f8a4c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/AppHeader.vue
// module id = 481
// module chunks = 7